/**
 * 下载工具函数
 */
import { API_HOST } from './constants';

/**
 * 下载 Blob 为文件
 */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * 下载单个资源
 */
export async function downloadResource(id, filename) {
  const response = await fetch(`${API_HOST}/api/resource/download/${id}`);
  if (!response.ok) {
    throw new Error('下载失败');
  }
  const blob = await response.blob();
  downloadBlob(blob, filename);
}

/**
 * 批量下载资源（ZIP）
 */
export async function downloadBatch(ids) {
  const response = await fetch(`${API_HOST}/api/resource/download/batch`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(ids)
  });
  if (!response.ok) {
    throw new Error('批量下载失败');
  }
  const blob = await response.blob();
  downloadBlob(blob, `资源_${Date.now()}.zip`);
}

/**
 * 下载文件夹（某个分镜号/集数下所有资源）
 */
export async function downloadFolder(projectId, episodeId, shotNumber) {
  const params = new URLSearchParams({ projectId: projectId.toString() });
  if (episodeId) params.append('episodeId', episodeId.toString());
  if (shotNumber) params.append('shotNumber', shotNumber.toString());

  const response = await fetch(`${API_HOST}/api/resource/download/folder?${params}`, {
    method: 'POST'
  });
  if (!response.ok) {
    throw new Error('文件夹下载失败');
  }
  const blob = await response.blob();

  let folderName = `project_${projectId}`;
  if (episodeId) folderName += `_ep${episodeId}`;
  if (shotNumber) folderName += `_shot${String(shotNumber).padStart(3, '0')}`;

  downloadBlob(blob, `${folderName}.zip`);
}
